<div class="modal on" role="dialog" aria-modal="true" aria-labelledby="df-mm-title">
  <div class="dr-h">
    <div style="flex:1">
      <h3 id="df-mm-title">Report a missing document</h3>
      <div class="hint">Give enough detail that the agent, or a colleague, could find it and recognise it.</div>
    </div>
    <button type="button" class="icon-btn" style="color:var(--ink-2)" aria-label="Close" [disabled]="busy" (click)="cancel()"><df-icon name="x"></df-icon></button>
  </div>

  <form class="dr-b form" (ngSubmit)="save()">
    <fieldset class="upload-fields" [disabled]="busy">
    <div><label class="req" for="m-type">Document type</label>
      <select id="m-type" class="fld" name="type" [(ngModel)]="form.type">
        <option *ngFor="let k of types" [value]="k">{{ docTypes[k].short }}</option>
      </select></div>
    <div><label class="req" for="m-land">Landscape</label>
      <select id="m-land" class="fld" name="land" [(ngModel)]="form.land">
        <option value="asis">As-Is (ECC)</option><option value="tobe">To-Be (S/4HANA)</option>
      </select></div>
    <div><label class="req" for="m-l2">L2 process</label>
      <select id="m-l2" class="fld" name="l2" [(ngModel)]="form.l2">
        <option *ngFor="let x of l2" [value]="x.id">{{ x.id }} {{ x.name }}</option>
      </select></div>
    <div><label for="m-l3">L3 code or scope item <small>(if known)</small></label>
      <input id="m-l3" class="fld" name="l3" [(ngModel)]="form.l3" placeholder="e.g. LSC-630-020 or BJ8"></div>
    <div class="full"><label class="req" for="m-title">Title or filename, as you remember it</label>
      <input id="m-title" class="fld" name="title" [(ngModel)]="form.title" (ngModelChange)="titleInvalid = false"
        [style.border-color]="titleInvalid ? 'var(--red)' : null" placeholder="e.g. CDD_HCVC_Enable Make_WIP rules"></div>
    <div class="full"><label for="m-loc">Where it lives <small>(library, folder or link)</small></label>
      <input id="m-loc" class="fld" name="loc" [(ngModel)]="form.loc" placeholder="e.g. Digital Core Data › Explore › L1 – Production Execution › DC Documents"></div>
    <div><label for="m-owner">Owner or author</label>
      <input id="m-owner" class="fld" name="owner" [(ngModel)]="form.owner" placeholder="e.g. Maddela, Rama"></div>
    <div><label for="m-date">Approximate date</label>
      <input id="m-date" class="fld" name="date" [(ngModel)]="form.date" placeholder="e.g. Aug 2026"></div>
    <div class="full"><label for="m-marker">How would you recognise it? <small>(what is inside)</small></label>
      <textarea id="m-marker" class="fld" name="marker" [(ngModel)]="form.marker" placeholder="e.g. Section 3 has a WIP transport rules table; the cover page says “Configuration Design – Digital Core”"></textarea></div>
    <div class="full"><label for="m-why">Why is it needed for Explore?</label>
      <textarea id="m-why" class="fld" name="why" [(ngModel)]="form.why" placeholder="e.g. It is the only to-be configuration record for EM.04 performance standards"></textarea></div>
    <div class="full upload-section" *ngIf="!form.attachment">
      <label for="m-file">Actual document <small>(optional)</small></label>
      <input #fileInput id="m-file" type="file" accept=".pdf,.docx,.xlsx,.pptx,.bpmn"
        aria-describedby="m-upload-help" (change)="selectFile($event)">
      <p id="m-upload-help" class="hint">One PDF, DOCX, XLSX, PPTX, or BPMN file, up to 20 MiB. Stored in Blob Storage; not yet searchable. Ingestion will be added later.</p>
      <p *ngIf="file">{{ file.name }} · {{ file.size | number }} bytes</p>
      <button type="button" class="btn" *ngIf="file || fileInvalid" (click)="clearFile(fileInput)">Clear selection</button>
    </div>
    <div class="full upload-section" *ngIf="form.attachment as attachment">
      <label>Attached document</label>
      <button type="button" class="link" (click)="download()">{{ attachment.name }}</button>
      <p class="hint">{{ attachment.size | number }} bytes · Uploaded; not yet searchable. Replacement and removal are not supported.</p>
    </div>
    </fieldset>
    <p class="full upload-error" role="alert" *ngIf="error">{{ error }}</p>
    <p class="full hint" role="status" *ngIf="busy">Saving or downloading document…</p>
  </form>

  <div class="dr-f">
    <button type="button" class="btn cancel-btn" [disabled]="busy" (click)="cancel()">Cancel</button>
    <button type="button" class="btn pri save-btn" [disabled]="busy || fileInvalid" (click)="save()">{{ busy ? 'Please wait…' : isEdit ? 'Save changes' : 'Report missing document' }}</button>
  </div>
</div>
